export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_SKELETON_CHECKLISTS_COUNT = 2

export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_SKELETON_ITEMS_COUNT = 4
